var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-area item-bg2"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"page-title-content"},[_c('h2',[_vm._v("Team")]),_c('p',[_vm._v("Meet our team")])])])])
}]

export { render, staticRenderFns }